import { connect } from 'react-redux';

import PhoneNumberControl from './PhoneNumberControl';
import { RootState } from 'app/store/rootReducer';
import {
  DispatchToPropsInterface,
  PhoneNumberControlProps,
  StateToPropsInterface,
} from './PhoneNumberControl.interfaces';
import { getBulbMessage } from 'app/store/data/formsConfig';

const mapStateToProps = (state: RootState, props: PhoneNumberControlProps) => ({
  bulbInfoMessage: props.formName
    ? getBulbMessage(state, props.formName, props.questionKey)
    : undefined,
});

const mapDispatchToProps = () => ({});

const PhoneNumberControlContainer = connect<
  StateToPropsInterface,
  DispatchToPropsInterface
>(
  mapStateToProps,
  mapDispatchToProps
)(PhoneNumberControl);

export default PhoneNumberControlContainer;
